import * as React from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { aidaChatKeys } from '../constants/query-keys'
import { conversationMediaFrom } from '../utils/conversation-media'
import { conversationQueryOptions, useConversationQuery } from './use-conversation'

export function useAidaConversationMedia(conversationId: string | null) {
  const conversationQuery = useConversationQuery(conversationId)
  const queryClient = useQueryClient()
  const busy = conversationQuery.data?.busy === true
  const wasBusy = React.useRef(busy)

  React.useEffect(() => {
    if (wasBusy.current && !busy && conversationId) {
      void queryClient.invalidateQueries({
        queryKey: aidaChatKeys.conversation(conversationId),
      })
    }
    wasBusy.current = busy
  }, [busy, conversationId, queryClient])

  const mediaQuery = useQuery({
    ...conversationQueryOptions(conversationId),
    select: conversationMediaFrom,
  })

  return {
    items: mediaQuery.data ?? [],
    isLoading: Boolean(conversationId) && mediaQuery.isPending,
  }
}
